export { OUTPUT_STRING } from './base64-decode'
export { OUTPUT_TYPED_ARRAY } from './base64-decode'
export { default as encode } from './base64-encode'
export { default as decode } from './base64-decode'
